import {makeStyles} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import MessagesConversation from '../../Sms/components/Messages/MessagesConversation';
import {useSelector} from 'react-redux';
import {getLastMessage} from '@shared/services/MessageService';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import Loader from '@components/framework/loader/Loader';
import {getClinicUsersList} from '@shared/services/ClinicServices';
import {UserModelMapper} from '@shared/services/service-mappers/ModelMapper';

const styles = makeStyles({
  messageConversionWrapper: {
    padding: '0.5rem',
    display: 'flex'
  }
});

const MessagesContainer = (): JSX.Element => {
  // FIXME: ADD PROPER TYPES
  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );
  const {enqueueSnackbar} = useSnackbar();
  const groupId = useSelector((state: any) => state.auth.groupId);

  const [messageId, setMessageId] = useState(null);
  const [loadingMessageId, setLoadingMessageId] = useState(true);
  const [groupUsersList, setGroupUsersList] = useState<Array<UserModelMapper>>(
    []
  );

  useEffect(() => {
    const getMessageId = async () => {
      try {
        const lastMessageObj = await getLastMessage(
          groupId,
          patientDetailsDrawer.clinicId,
          patientDetailsDrawer.patientDetails?.guarantor_id
        );
        setMessageId(lastMessageObj?.data?.id);
      } catch (err: any) {
        enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      } finally {
        setLoadingMessageId(false);
      }
    };
    const fetchClinicUsersList = async (): Promise<void> => {
      try {
        const response = await getClinicUsersList(
          groupId,
          patientDetailsDrawer.clinicId
        );

        if (Array.isArray(response?.data)) {
          setGroupUsersList(response?.data);
        } else {
          setGroupUsersList([]);
        }
      } catch (error: any) {
        enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
        throw error;
      }
    };

    getMessageId();
    fetchClinicUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const classes = styles();
  return (
    <div
      className={`patient-drawer-content ${classes.messageConversionWrapper}`}>
      {loadingMessageId && <Loader />}
      {!loadingMessageId && (
        <MessagesConversation
          clinicId={patientDetailsDrawer?.clinicId}
          groupId={groupId}
          messageId={messageId as any}
          guarantorId={patientDetailsDrawer?.patientDetails?.guarantor_id}
          groupUsers={groupUsersList}
        />
      )}
    </div>
  );
};

export default MessagesContainer;
